// imports section
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import { CardMedia } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import { Dayend_API_01, ENUSER } from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import marriott from "../../assets/images/marriott-logo.png";
import { useSelector, useDispatch } from "react-redux";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import { MSG_DAYEND_FAI, MSG_DAYEND_SUC } from "../../utils/sys/Messages";
import no_image from "../../assets/images/no_image.png";
import { BASEURL } from "../../config/Config";

const DayEnd = () => {
  // Hooks
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [details, setDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, STOREDATE, USERNAME, COMPANYLOGO } =
    SYS_USER.USER_PARAM || {};

  useEffect(() => {
    fetchData();
  }, []);

  // Handlers

  const companyLogoUrl = COMPANYLOGO
    ? `${COMPANYLOGO.replace("~/", "")}`
    : null;

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  //Api's
  const fetchData = async () => {
    try {
      const result = await externalgetApi(Dayend_API_01, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        STS: CON_STATUS_ACTIVE,
      });

      console.log("test", result);
      if (result && result.length > 0) {
        setDetails(result[0]);
      }
      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };

  const gotToPage = () => {
    navigate("/DayEnd");
  };

  const handleDayEndProcess = async () => {
    const today = new Date().toISOString().split("T")[0]; // Current date in YYYY-MM-DD format

    const payload = {
      compcode: COMPCODE,
      loccode: LOCCODE,
      restcode: RESTCODE,
      enuser: USERNAME, // Ensure ENUSER is defined/imported
      locdate: today,
      sts: CON_STATUS_ACTIVE,
    };

    try {
      const response = await externalpostApi(Dayend_API_01, payload);

      if (response) {
        setSnackbarMessage(MSG_DAYEND_SUC);
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        navigate("/DayEnd");
      } else {
        setSnackbarMessage(MSG_DAYEND_FAI);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error in Day End Process:", error);
      alert("An error occurred while processing Day End.");
    }
  };

  if (isLoading) return <Typography>Loading...</Typography>;
  if (error) return <Typography>Error loading data</Typography>;

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                {/* <Link underline="hover">Employee</Link> */}
                <Link underline="hover">Day End</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                {/* Add any additional buttons or actions here */}
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.box_container}>
        <Box sx={{ alignContent: "center", width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              {" "}
              <Box sx={styles.col_title}>
                <Typography variant="title">Process Day End</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={12} mt={2} ml={0}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  marginLeft: 0,
                  width: "100%",
                  padding: 3, // Add padding inside the card
                  borderRadius: 1, // Rounded corners
                  boxShadow: 1,
                  background: theme.palette.background.tertiary,
                  overflow: "hidden",

                  height: "clamp(50vh, 65vh, 100vh)", // Min, preferred, and max height
                }}
              >
                <CardMedia
                  component="img"
                  src={companyLogoUrl || no_image} // If marriott is static, else use details.COMPCODE based logic
                  sx={{
                    width: 180,
                    height: 180,
                    p: 2,
                    maxWidth: "240px",
                    mt: 2,
                    mb: 2,
                    border: `3px solid ${theme.palette.background.paper}`,
                    boxShadow: 2,
                    transition: "transform 0.3s",
                    "&:hover": { transform: "scale(1.1)" },
                  }}
                />
                <Typography
                  variant="h5"
                  sx={{
                    // marginTop: 2,
                    fontWeight: 600,
                    color: theme.palette.text.primary,
                  }}
                >
                  {details?.RESTNAME}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: theme.palette.text.secondary,
                    marginTop: 1,
                  }}
                >
                  {details?.ADDRESS}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    marginTop: 1,
                  }}
                >
                  Hotline: {details?.HOTLINE}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    marginTop: 1,
                  }}
                >
                  Fax: {details?.FAX}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    marginTop: 1,
                  }}
                >
                  {details?.EMAIL}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    marginTop: 1,
                  }}
                >
                  {new Date(STOREDATE).toLocaleDateString()}
                </Typography>
                <Button
                  onClick={handleDayEndProcess}
                  variant="contained"
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "220px",
                    marginTop: 2,
                  }}
                >
                  Day End Process
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity} // Dynamic severity (success or error)
      />
    </div>
  );
};

export default DayEnd;
